"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    envHeaderPlugin: ()=>envHeaderPlugin
});
const ENV_HEADER = 'X-Tt-Env';
const USE_BOE_HEADER = 'X-USE-BOE';
function envHeaderPlugin(envHeaderConfig) {
    return {
        request: [
            (config)=>{
                var _envHeaderConfig_paramName;
                const paramName = null != (_envHeaderConfig_paramName = null == envHeaderConfig ? void 0 : envHeaderConfig.paramName) ? _envHeaderConfig_paramName : 'x-branch';
                const urlInfo = new URL(window.location.href);
                let header = urlInfo.searchParams.get(paramName);
                if ('string' == typeof (null == envHeaderConfig ? void 0 : envHeaderConfig.branchPrefix) && header) header = header.replace(new RegExp(`^${envHeaderConfig.branchPrefix}`), '');
                if (!header) return config;
                var _config_headers;
                config.headers = null != (_config_headers = config.headers) ? _config_headers : {};
                const disabledHeaders = Array.isArray(null == envHeaderConfig ? void 0 : envHeaderConfig.disabledHeaders) ? null == envHeaderConfig ? void 0 : envHeaderConfig.disabledHeaders : [];
                if (!(null == disabledHeaders ? void 0 : disabledHeaders.includes(USE_BOE_HEADER))) config.headers[USE_BOE_HEADER] = '1';
                if (!(null == disabledHeaders ? void 0 : disabledHeaders.includes(ENV_HEADER))) config.headers[ENV_HEADER] = `boe_${header}`;
                return config;
            }
        ]
    };
}
exports.envHeaderPlugin = __webpack_exports__.envHeaderPlugin;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "envHeaderPlugin"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
